import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-pwa-popup',
    templateUrl: './pwa-popup.component.html',
    styleUrls: ['./pwa-popup.component.css'],
    imports: [TranslateModule]
})
export class PwaPopupComponent implements OnChanges {

  @Input() showModal: boolean;
  @Input() installPWA: () => void;
  @Output() userResponse: EventEmitter<boolean> = new EventEmitter<boolean>();

  isOpen = false;

  constructor() {
    this.showModal = false;
  }

  closeModal(accepted: boolean = false) {
    this.isOpen = false;
    this.userResponse.emit(accepted);
  }

  install() {
    this.installPWA?.();
    this.closeModal(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showModal']) {
      this.isOpen = !!changes['showModal'].currentValue;
    }
  }
}
